import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import EmployeeDashboard from "./Features/Frotend/EmployeeDashboard/EmployeeDashboard";
import AddTicketForm from "./Features/Frotend/Ticket/TicketForm/addTicketForm";
import EmpTicketTable from "./Features/Frotend/Ticket/TicketTable/empTicketTable";
import FullLayout from "./Layouts/Full/FullLayout/fullLayout";
import PageNotFound from "./Ui/404/404";
import ProtectedRoutes from "./Ui/ProtectedRoutes/protectedRoutes";
import ViewForm from "./Features/Frotend/CommentBox/ViewTickets";
import { AssignModal } from "./Features/Frotend/Ticket/AssignModal/assignModal";
import Footer from "./Ui/Footer/Footer(1)";
import { useEffect, useState } from "react";
import Login from "./Features/Frotend/Login/login";
import Cookies from "universal-cookie";
import { Logger } from "./Logger/Logger";
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();
  useEffect(() => {
    const timeout = setTimeout(() => {
      Logger.debug("in timeout ", timeout);
    
      setIsLoggedIn(false);
      cookies.remove("UserLogin");
      cookies.remove("UserDetails");
      cookies.remove("adminRole");
      cookies.remove("sysAdminRole");
      cookies.remove("createdBy");
      cookies.remove("UserLoginAccessToken");
      cookies.remove("UserName")
      navigate("/");
    }, 5184000); // 24 hrs

    return () => clearTimeout(timeout);
  }, [isLoggedIn]);
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<Login setIsLoggedIn={setIsLoggedIn}></Login>}
        ></Route>

        <Route
          path="/secured"
          element={<ProtectedRoutes Component={FullLayout} />}
        >
          <Route
            path="empDashboard"
            element={<EmployeeDashboard></EmployeeDashboard>}
          ></Route>
          <Route
            path="addTicket"
            element={
              <div>
                <AddTicketForm />{" "}
              </div>
            }
          ></Route>
          <Route path="ticketList" element={<EmpTicketTable />}></Route>
          <Route path=":id" element={<ViewForm />}></Route>
          <Route path="assign" element={<AssignModal></AssignModal>}></Route>
        </Route>
        <Route path="/*" element={<PageNotFound />}></Route>
      </Routes>
      {/* <Footer/> */}
    </>
  );
};
export default App;
